/* src/app/job-signoff-artic/pages/job-signoff-artic/job-signoff-artic.component.scss */
/*# sourceMappingURL=job-signoff-artic.component.css.map */
